import { apm } from "@elastic/apm-rum";
import { Box, Button, Divider, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import {
  Cursor as CursorIcon,
  CursorWithPoints,
} from "shared/common/utils/icons/measurementIcons";

export interface Tool {
  id: string;
  icon: JSX.Element;
}

export default function CursorContent() {
  const { t } = useTranslation();

  const darkTheme = defaultStore((state) => state.darkTheme);

  const activeCursorTool = sidebarStore((state) => state.activeCursorTool);
  const changeActiveCursorTool = sidebarStore(
    (state) => state.changeActiveCursorTool
  );
  const changeCursorPopover = sidebarStore(
    (state) => state.changeCursorPopover
  );

  // close cursor popover
  const handleClose = () => {
    changeCursorPopover(false);
  };

  //cursor tools
  const tools: Tool[] = [
    {
      id: "circle",
      icon: <CursorIcon />,
    },
    {
      id: "points",
      icon: <CursorWithPoints />,
    },
  ];

  //change cursor model and close immediatly after changing it
  const handleCursor = (item: Tool) => {
    if (activeCursorTool && activeCursorTool.id !== item.id) {
      changeActiveCursorTool(item);
      handleClose();
    }
  };

  //timeout for showing cursor popover when users are just hovering it
  let waitTime: NodeJS.Timeout | null = null;
  const stopShowing = () => {
    waitTime = setTimeout(() => {
      changeCursorPopover(false);
    }, 1000);
    return () => {
      if (waitTime !== null) clearTimeout(waitTime);
    };
  };
  const clearTimeoutFunction = () => {
    if (waitTime !== null) {
      clearTimeout(waitTime);
    }
  };

  //by default select first cursor tool
  useEffect(() => {
    if (activeCursorTool === undefined) {
      changeActiveCursorTool(tools[0]);
    }
  }, []);

  return (
    <Box
      onMouseOut={stopShowing}
      onMouseOver={clearTimeoutFunction}
      sx={{
        position: "absolute",
        left: "calc(100% + 8px)",
        top: "120px",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        backgroundColor: darkTheme ? "darkblue.main" : "white",
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box
          sx={{
            padding: 1,
            width: "auto",
          }}
        >
          <Typography
            sx={{
              whiteSpace: "nowrap",
              color: darkTheme ? "white" : "darkblue.main",
            }}
          >
            {t("cursor.title")}
          </Typography>
        </Box>
        {/* <Box
          display={"flex"}
          flexDirection="row"
          gap={1}
          paddingX={1}
          alignItems="center"
          sx={{ color: darkTheme ? "white" : "darkblue.main" }}
        >
          <IconButton
            sx={{
              padding: 0,
              marginY: 1,
              color: darkTheme ? "white" : "darkblue.main",
              ":hover": { color: "secondary.main" },
            }}
            onClick={handleClose}
            disableRipple={true}
          >
            <Close />
          </IconButton>
        </Box> */}
      </Box>
      <Box
        sx={{
          padding: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            marginBottom: 1,
            backgroundColor: darkTheme ? "primary.light" : "grey.light",
          }}
        >
          {tools.map((item) => (
            <Button
              disableRipple
              key={item.id}
              id={item.id}
              onClick={() =>
                monitor(
                  apm,
                  "change-3d-cursor | Cursor",
                  () => handleCursor(item),
                  { cursorType: item.id }
                )
              }
              sx={{
                width: "25%",
                textAlign: "center",
                borderRadius: "0px",
                color:
                  activeCursorTool?.id === item.id
                    ? "secondary.main"
                    : darkTheme
                      ? "white"
                      : "darkblue.main",
                backgroundColor:
                  activeCursorTool?.id === item.id
                    ? darkTheme
                      ? "darkblue.main"
                      : "white"
                    : "",
              }}
            >
              {item.icon}
              {activeCursorTool?.id === item.id && (
                <Divider
                  sx={{
                    position: "absolute",
                    bottom: "0",
                    left: "50%",
                    backgroundColor: "secondary.main",
                    borderRadius: "4px 4px 0px 0px",
                    height: "2px",
                    marginLeft: "-12px",
                    width: "24px",
                  }}
                />
              )}
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
